<div id="blogging" class="my-5">
    <div class="container-fluid px-2 px-lg-5">
        <div class="row">
            <div class="col-12" data-scroll>
                <h2 class="font-weight-bold text-center">MPPS BLOG</h2>
                <hr class=" p-1 opacity-100 mx-auto" style="width: 160px;">
                
            </div>
        </div>
        
        <owl-carousel-o [options]="customOptions">

            <ng-container *ngFor="let blog of blogs; let i=index">
              <ng-template carouselSlide >
                <div class="blog-item-inner shadow-dark mx-auto">
                    <div class="blog-img">
                      <img [src]="blog.imgUrl" alt="Blog">
                      <div class="blog-date">
                        {{blog.author}}
                      </div>
                    </div>
                    <div class="blog-info">
                      <h4 class="blog-title">{{blog.title}}</h4>
                     
                        <p class="blog-description" [innerHtml]="blog.shortDes"></p>
                      <!-- <p class="blog-description">I need a job to get experience, but I need experience to get a job. Either way, you need a resume, and what you don't need is to panic.</p> -->
                      <p class="blog-tags"><a [routerLink]="['/blog',blog.$key]" > Read More...</a></p>
                    </div>
                  </div>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        
       
    </div>
</div>








